export default "__VITE_ASSET__BAd1SrwD__";